var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158fb0b4c057c56f3e375fd_icon-security.svg",
    clipPath: "url(#clip0_13_464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-10",
    d: "M23 45.9193C35.4264 45.9193 45.5 35.8457 45.5 23.4193C45.5 10.9929 35.4264 0.919312 23 0.919312C10.5736 0.919312 0.5 10.9929 0.5 23.4193C0.5 35.8457 10.5736 45.9193 23 45.9193Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7755 13.4204C17.3748 13.3894 12.8963 17.6809 12.7273 23.1084C12.5526 28.6221 16.891 33.2396 22.4063 33.4144C27.9188 33.5861 32.5424 29.2471 32.7172 23.7335C32.8889 18.2199 28.5507 13.5952 23.0383 13.4204C22.9521 13.4177 22.8613 13.4209 22.7755 13.4204ZM22.972 14.5314C23.0501 14.5318 23.1278 14.529 23.2062 14.5314C25.4981 14.6035 27.5582 15.5089 29.1111 16.945L15.8961 29.2526C14.5477 27.6257 13.7653 25.53 13.8379 23.2572C13.9918 18.359 18.0551 14.5028 22.972 14.5314Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.919312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon-security.522a6600aa2c2214ff0d63c35992a88d.svg";
export { ForwardRef as ReactComponent };